const moneda = 'C$';

export default moneda;
